import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import QuickGift from './QuickGift/QuickGift';


const PopularGifts = ({ gifts, onClickHandler, isDesktop }) => {
  const giftRender = gifts.map((item, i) => (
    <QuickGift
      key={`popularGiftItem-${i}`}
      {...item}
      isDesktop={isDesktop}
      onClickHandler={onClickHandler}
    />
  ));

  return (
    <Fragment>
      {giftRender}
    </Fragment>
  );
};

PopularGifts.propTypes = {
  gifts: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onClickHandler: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
};

PopularGifts.defaultProps = { isDesktop: undefined };

export default PopularGifts;
